import formatClearSvg from '@listening/assets/astro/images/format-clear.svg';
import speakLineSvg from '@listening/assets/astro/images/speak-line.svg';
import voiceLivWebp from '@listening/assets/astro/images/voice-avatars/voice-liv.webp';
import voiceWillWebp from '@listening/assets/astro/images/voice-avatars/voice-will.webp';
import voiceprintLineSvg from '@listening/assets/astro/images/voiceprint-line.svg';

import { ContactIsland } from '@/components/astro/features/contact/contact-island';
import { VoiceSample } from '@/components/astro/features/voice-sample';

export function HeroHeadingContactSection() {
  return (
    <section className='flex w-full flex-col-reverse items-center justify-center gap-[150px] overflow-hidden px-5 py-13 pb-0 sm:px-14 sm:py-18 md:flex-row md:gap-0 lg:px-18'>
      <div className='flex w-full max-w-[1296px] flex-col-reverse items-center justify-between gap-18 pt-13 sm:pt-0 lg:flex-row-reverse'>
        <div className='mr-0 flex w-full flex-[1_0] lg:flex lg:w-auto'>
          <div className='relative flex w-full items-center justify-center lg:justify-start'>
            <div className='inline-flex w-full max-w-[580px] flex-col items-center justify-start gap-8 rounded-xl bg-white p-10 shadow transition-all lg:min-h-[490px] lg:w-auto lg:min-w-[400px] 2xl:min-w-[574px]'>
              {/* <!-- Leadmonk inline widget begin --> */}
              <div
                data-baseurl='https://apiv1.leadmonk.io/leadmonk'
                data-formid='book-a-demo'
                data-formtype='custom'
                data-routerid='QcFVHQNjQH7acGlpsSTr'
                id='leadmonk-router-inline'
              />
              {/* <script
                type="text/javascript"
                src="https://firebasestorage.googleapis.com/v0/b/leadmonk-prod.appspot.com/o/leadmonk%2Fembed%2Fformembed.js?alt=media"
                async
              ></script> */}
              {/* <!-- Leadmonk inline widget end --> */}
              <ContactIsland />
            </div>

            <div className='absolute inset-0 z-[-1] flex items-center justify-center xl:mr-100'>
              <div className='absolute size-[550px] rounded-full border border-cloud-250 bg-cloud-250/10 opacity-60' />
              <div className='absolute size-[414px] rounded-full border border-cloud-250 bg-cloud-250/20 opacity-70' />
              <div className='absolute size-[740px] rounded-full border border-cloud-250 opacity-50' />
              <div className='absolute size-[1044px] rounded-full border border-cloud-250 opacity-30' />
            </div>
          </div>
        </div>
        <div className='relative flex w-full flex-[0_4_644px] [flex-basis:630px] flex-col items-start gap-8'>
          <div className='flex flex-col items-start gap-7'>
            <div className='font-["Poppins"] text-[40px] leading-[43.20px] font-bold text-neutral-945'>
              For Institutions:
            </div>
            <h1 className='block text-[32px] leading-[34px] font-[700] text-neutral-945 sm:text-[48px] sm:leading-[51px] lg:text-[3.25rem] lg:leading-[1.08]'>
              Want to bring Listening to{' '}
              <span className='text-azure-455'>your students?</span>
            </h1>
          </div>
          <div className='flex max-w-[504px] flex-[0_auto] flex-col items-start justify-start gap-6 p-0'>
            <div className='flex items-start gap-4'>
              <img
                alt='Voice print icon'
                loading='lazy'
                src={voiceprintLineSvg}
              />
              <div className='text-[1rem] leading-normal font-[500] text-neutral-840 sm:text-[1.25rem]'>
                Listen to academic papers, including complex scientific material
              </div>
            </div>
            <div className='flex items-start gap-4'>
              <img alt='Speaking icon' loading='lazy' src={speakLineSvg} />
              <div className='text-[1rem] leading-normal font-[500] text-neutral-840 sm:text-[1.25rem]'>
                Removes references, citations, and footnotes automatically
              </div>
            </div>
            <div className='flex items-start gap-4'>
              <img alt='Format icon' loading='lazy' src={formatClearSvg} />
              <div className='text-[1rem] leading-normal font-[400] text-neutral-840 sm:text-[1.25rem]'>
                Voices that sound just like a real person speaking
              </div>
            </div>
          </div>

          <hr className='mt-6 w-full border-[1.5px] border-steel-120' />

          <div className='flex flex-col gap-4'>
            <div className='flex flex-col flex-wrap gap-4 md:flex-row'>
              <VoiceSample
                audioSrc='https://webflow-cdn.listening.com/voice-samples/will-2.mp3'
                imgSrc={voiceWillWebp}
                label='Computer Science'
              />
              <VoiceSample
                audioSrc='https://webflow-cdn.listening.com/voice-samples/liv-3.mp3'
                imgSrc={voiceLivWebp}
                label='Biology'
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
